module.exports = __webpack_public_path__ + "img/streaming_flowers.d6fb0069.svg";